// Regex taken from https://github.com/bvaughn/highlight-words-core
function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function combineSearchWords(words) {
  const escaped = words.filter(Boolean).map((word) => escapeRegExp(word.trim()));
  if (escaped.length === 0) return null;
  return new RegExp(`(${escaped.join('|')})`, 'gi');
}

const HighlightedText = ({ text, query }) => {
  if (!query) return text;

  const regex = combineSearchWords([query]);
  if (!regex) return text;

  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <mark key={i} className="font-bold bg-[Highlight] transition-colors duration-200">
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
};

export default HighlightedText;
